<ng-container *ngIf="filterForm">
    <div class="filters">
        <form [formGroup]="filterForm">
            <!-- Search  -->
            <div class="search search-container">
                <app-basic-input
                    [inputConfig]="{ inputId: 'search', placeholder: filterConfig.searchPlaceholder, type: basicInputTypeEnum.TEXT }"
                    [classes]="'icon icon__search'"
                    [icons]="'i-search'"
                    formControlName="search"
                ></app-basic-input>
                <a
                    *ngIf="filterConfig.hasDateRange || filterConfig.checkboxGroups?.length > 0"
                    aria-controls="repertoire filter"
                    aria-expanded="true"
                    class="horizontal collapsible-container"
                    data-bs-toggle="collapse"
                    href="#filter"
                    role="button"
                    (click)="showFilter = true"
                >
                    <span class="icon i-filter" [ngClass]="{ 'right-tab': search.value }"></span>
                </a>
                <button
                    *ngIf="search.value"
                    class="close-filter icon i-close"
                    [title]="'SHARED.FILTERS.REINIT' | translate"
                    (click)="resetFilter()"
                ></button>
            </div>
            <!-- Filters Opened -->
            <div class="collapse filters_inner" id="filter" [ngClass]="{ show: showFilter }">
                <button *ngIf="showFilter" class="close-filter icon i-close" (click)="showFilter = false"></button>
                <div class="filters_title-container">
                    <h3 class="filters_title">{{ 'SHARED.FILTERS.TITLE' | translate }}</h3>
                </div>
                <!-- Date Range -->
                <ng-container *ngIf="filterConfig.hasDateRange">
                    <div class="row mb-m">
                        <div class="col-lg-6 col-md-12">
                            <label class="filters_label mb-xs" for="start">{{ 'SHOP.FROM' | translate }}</label>
                            <app-basic-input
                                [inputConfig]="{ inputId: 'search', placeholder: '', type: basicInputTypeEnum.DATE }"
                                [classes]="'icon icon__search'"
                                formControlName="dateStart"
                                id="start"
                            ></app-basic-input>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <label class="filters_label mb-xs" for="end">{{ 'SHOP.TO' | translate }}</label>
                            <app-basic-input
                                [inputConfig]="{ inputId: 'search', placeholder: '', type: basicInputTypeEnum.DATE }"
                                [classes]="'icon icon__search'"
                                formControlName="dateEnd"
                                id="end"
                            ></app-basic-input>
                        </div>
                    </div>
                    <div class="error" *ngIf="isDateRangeInError && showFilter">{{ 'ERRORS.FORMS.DATE_RANGE' | translate }}</div>
                </ng-container>
                <!-- Checkbox groups -->
                <div class="row">
                    <ng-container *ngFor="let checkboxGroup of filterConfig.checkboxGroups">
                        <div *ngIf="checkboxGroup.enable" [class]="checkboxGroup.child ? 'col-4' : 'col-lg-6 col-sm-12 mb-s'">
                            <label class="filters_label mb-xs">{{ checkboxGroup.label | translate }}</label>
                            <app-generic-checkbox
                                [data]="checkboxGroup.options"
                                [labelRef]="'label'"
                                [valueRef]="'value'"
                                [formControl]="getControl(checkboxGroup.id)"
                                [id]="checkboxGroup.id"
                            >
                            </app-generic-checkbox>
                            <ng-container *ngIf="checkboxGroup.child?.length > 0">
                                <ng-container *ngFor="let child of checkboxGroup.child">
                                    <div>
                                        <label *ngIf="child.label" class="filters_label mb-xs">{{ child.label | translate }}</label>
                                        <app-generic-checkbox
                                            [data]="child.options"
                                            [labelRef]="'label'"
                                            [valueRef]="'value'"
                                            [formControl]="getControl(child.id)"
                                            [id]="child.id"
                                        >
                                        </app-generic-checkbox>
                                        <ng-container *ngIf="child.child?.length > 0">
                                            <ng-container *ngFor="let subchild of child.child">
                                                <div class="child">
                                                    <label *ngIf="subchild.label" class="filters_label mb-xs">{{
                                                        subchild.label | translate
                                                    }}</label>
                                                    <app-generic-checkbox
                                                        [data]="subchild.options"
                                                        [labelRef]="'label'"
                                                        [valueRef]="'value'"
                                                        [formControl]="getControl(subchild.id)"
                                                        [id]="subchild.id"
                                                    >
                                                    </app-generic-checkbox>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
                <!-- Actions Buttons -->
                <div class="buttons-container spaces">
                    <!-- Apply -->
                    <app-generic-button
                        [inputText]="'SHARED.FILTERS.APPLY'"
                        [classes]="'btn btn--primary'"
                        (buttonClick)="emitFilters()"
                    ></app-generic-button>
                    <!-- Reset -->
                    <app-generic-button
                        [inputText]="'SHARED.FILTERS.RESET'"
                        [classes]="'btn btn--secondary'"
                        (buttonClick)="resetFilter()"
                    ></app-generic-button>
                    <!-- Other actions -->
                    <ng-container *ngFor="let action of filterConfig.actions">
                        <ng-container *appCheckPermissions="action.permission">
                            <app-generic-button
                                [inputText]="action.label"
                                [classes]="'btn btn--primary icon i-download'"
                                (buttonClick)="action.action()"
                            >
                            </app-generic-button>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </form>
    </div>
</ng-container>
